import { Box, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from "@material-ui/core";
import { Field, FieldProps } from "formik";

type RadioFieldProps = {
  name: string;
  label: string;
  options: any[];
  valueKey: string;
  labelKey: string;
  row?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>, value: string) => void;
};

const RadioField = ({ name, label, options, valueKey, labelKey, row = false, onChange }: RadioFieldProps) => {
  return (
    <Field name={name}>
      {({ field, form }: FieldProps) => (
        <FormControl component="fieldset" error={Boolean(form.touched[name] && form.errors[name])}>
          <Box display={row ? "flex" : "block"} alignItems="center">
          <FormLabel component="legend" sx={{ mr: row ? 2 : 0 }}>{label}</FormLabel>
          <RadioGroup
            {...field}
            name={name}
            row={row}
            onChange={(event) => {
              form.setFieldValue(name, event.target.value);
              if (onChange) {
                onChange(event, event.target.value);
              }
            }}
          >
            {options.map((option) => (
              <FormControlLabel
                key={option[valueKey]}
                value={option[valueKey]}
                control={<Radio />}
                label={option[labelKey]}
              />
            ))}
          </RadioGroup>
          </Box>
        </FormControl>
      )}
    </Field>
  );
};

export default RadioField;
